import { Work } from "@/lib/types";

export const works: Work[] = [
  {
    'name': 'GraphWorks',
    'desc': 'Headphones.com\'s headphone measurement repository and visualization platform.',
    'media': 'graphworks.jpg',
    'link': 'https://graph.headphones.com',
    'slug': 'graphworks',
    'status': 'Active',
    'tech': ['SCSS', 'TS', 'React', 'Visx'],
    'tags': ['Design', 'Development', 'Fullstack'],
    'duration': [2025, 2026],
  },
  {
    'name': 'INM Audio',
    'desc': 'Proudly Philippine-built custom in-ear monitors.',
    'media': 'inm-audio.png',
    'link': 'https://inmaudio.com',
    'slug': 'inm-audio',
    'status': 'Active',
    'tech': ['SCSS', 'TS', 'React', 'Three', 'R3F'],
    'tags': ['Design', 'Development', '3D Interactivity'],
    'duration': [2024, 2026],
  },
  {
    'name': 'Dev Protocol',
    'desc': 'Decentralized funding for sustainable creator economy.',
    'media': 'devprotocol.webp',
    // 'link': 'https://devprotocol.xyz',
    'slug': 'dev-protocol',
    'status': 'Archived',
    'tech': ['SCSS', 'Tailwind', 'TS', 'React', 'Vue', 'Svelte'],
    'tags': ['Design', 'Development', 'Design System'],
    'duration': [2021, 2024],
  },
  {
    'name': 'wearecoral',
    'desc': 'Support the artists and music scenes you love.',
    'media': 'wearecoral/wearecoral-conversion.webp',
    'slug': 'wearecoral',
    'link': 'https://www.wearecoral.org',
    'status': 'Active',
    'tech': ['Figma', 'React', 'Tailwind'],
    'tags': ['Design', 'Development', 'Marketing'],
    'duration': [2024]
  },
  {
    'name': 'GrowStocks',
    'desc': 'Growtopia\'s Online Price Checker and tech solutions company.',
    'media': 'growstocks.webp',
    'status': 'Archived',
    'slug': 'growstocks',
    'tech': ['SCSS', 'TS', 'React', 'PHP', 'Laravel'],
    'tags': ['Design', 'Development', 'Design System'],
    'duration': [2018, 2023]
  },
  {
    'name': 'Purple Cress',
    'desc': 'Purple Cress Scanlation\'s manga library and reader web application.',
    'media': 'purplecress.webp',
    'slug': 'purple-cress',
    'link': 'https://github.com/PurpleCress/website',
    'status': 'Archived',
    'tech': ['SCSS', 'TS', 'Vue', 'Firebase'],
    'tags': ['Design', 'Development', 'Web App'],
    'duration': [2021, 2022]
  },
  {
    'name': 'Pycord',
    'desc': 'The library for making discord bots in python.',
    'media': 'pycord.webp',
    'link': 'https://pycord.dev',
    'slug': 'pycord',
    'status': 'Active',
    'tech': ['SCSS', 'TypeScript', 'React', 'Python'],
    'tags': ['Development', 'Website', 'Open Source'],
    'duration': [2022]
  },
  {
    'name': 'A-PEERS 2022',
    'desc': 'Website in celebration of the National Arts Month 2022 in RLSAA.',
    'media': 'apeers.webp',
    'link': 'https://apeer-2022.vercel.app/',
    'slug': 'a-peers-2022',
    'status': 'Active',
    'tech': ['SCSS', 'TS', 'React'],
    'tags': ['Design', 'Development', 'Website'],
    'duration': [2022]
  },
  {
    'name': 'Luwal Sining-Pagganap',
    'desc': 'LSP\'s main website and performance platform.',
    'media': 'luwal.webp',
    'slug': 'luwal-sining-pagganap',
    'status': 'Archived',
    'tech': ['SCSS', 'PHP', 'Laravel'],
    'tags': ['Design', 'Development', 'Web App'],
    'duration': [2020, 2022]
  },
  {
    'name': 'BlockCorp',
    'desc': 'The platform to order Growtopia-related services.',
    'media': 'blockcorp.webp',
    'slug': 'blockcorp',
    'status': 'Archived',
    'tech': ['SCSS', 'Vue', 'Python', 'Flask'],
    'tags': ['Development', 'Web App'],
    'duration': [2020, 2021]
  },
  {
    'name': 'SurPathHub Documentation Site',
    'desc': 'The official documentation website for all open source SurPathHub projects.',
    'media': 'sph-docs.webp',
    'link': 'https://sph-docs.netlify.app/',
    'status': 'Archived',
    'tech': ['SCSS', 'TS', 'React', 'Docusaurus'],
    'tags': ['Development', 'Website', 'Open Source'],
    'duration': [2021]
  },
];
